<template>
    <tr :style="conditionalBorder">
        <td>{{ row.bus_company_name  }}</td> 
        <td>{{ this.$moment(row.day).format("DD/MM/YYYY") }}</td>
        <td>{{ row.excursion }}</td>
        <td>{{ row.bus.name }}</td>
        <td>{{ row.duration_name }} ({{ row.duration_code }})</td>
        <td>{{ row.guide != null ? row.guide.full_name : 'NOT_SET' }}</td>
        <td>{{ row.bus.max_size }}</td>
        <td class="text-right">{{ transformed_price }}</td>
        <td>{{ row.bus_fare_type_name != null ? row.bus_fare_type_name : 'NOT_SET' }}</td>
    </tr>
</template>

<script>
/* eslint-disable */
export default {
    components: {
        
    },
    props: {
        row: {
            type: Object,
            required: true
        },
        idx: {
            type: Number,
            required: false,
        },
        all: {
            type: Array,
            required: true,
        }
    },
    computed: {
        transformed_price() {
            if ( this.row.price ) {
                if ( this.row.price.includes('.') ) {
                    return this.row.price.replace('.', ',') + " €"
                }
            }
            return (this.row.price != null ) ? this.row.price : '--'
        },
        conditionalBorder() {
            if ( this.idx > 0 && this.all[this.idx-1].day !== this.row.day ) {
                return 'border-top: 1px solid #999;'
            }
        }
    }
}
</script>